module.exports = __webpack_public_path__ + "static/media/Badge_PngMarquePrivilege_Cerave.621958cb.png";